import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { Subject, throwError } from "rxjs";

import { environment } from "../environments/environment";
import { userDetails } from "src/app/models/user.model";

const BACKEND_URL = environment.apiUrl;

@Injectable({
  providedIn: "root",
})
export class UserDetailService {
  userDetails: userDetails[];
  agentId: string;
  userId = localStorage.getItem("userId");
  isAuthenticated = false;
  private token: string;
  private tokenTimer: any;
  private authStatusListener = new Subject<boolean>();
  userDetail: any;
  searchDetails: any;

  constructor(private http: HttpClient, private router: Router) {}

  getProfileDetails(name: string) {
    return this.http.get<{
      id: string;
      full_name: string;
      email: string;
      password: string;
      phone_number: string;
      address: string;
      city: string;
      state: string;
      permission: string;
      profilepicFilepath: string;
      bio1: string;
      bio2: string;
      bio3: string;
      position: string;
      facebookUrl: string;
      twitterUrl: string;
      linkedinUrl: string;
      agentMLS_ID: string;
    }>(BACKEND_URL + "/user/agent-profile/" + name);
  }

  getauthordetails(userid: String) {
    const URL = BACKEND_URL + "/user/" + userid;
    return this.http.get(URL);
  }

  getAgents() {
    const URL = BACKEND_URL + "/main-page/all-agents/";
    return this.http.get(URL);
  }

  getAdmins() {
    const URL = BACKEND_URL + "/main-page/all-admins/";
    return this.http.get(URL);
  }

  getEveryone() {
    const URL = BACKEND_URL + "/main-page/all-users/";
    return this.http.get(URL);
  }

  setUserDetails(userObject) {
    this.userDetail = userObject;
    this.router.navigate(["/" + userObject.full_name.split(" ").join("")]);
  }

  getUserDetails() {
    return this.userDetail;
  }
}
